import { render, staticRenderFns } from "./form-date-checkbox.vue?vue&type=template&id=013da890&"
import script from "./form-date-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-date-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-date-checkbox.vue"
export default component.exports